/**
 * 몰 sticky 헤더 하단까지의 거리를 CSS 변수로 공개한다.
 * 장바구니·결제·주문상세·마이페이지 사이드 sticky top 이 이 값을 쓴다.
 *
 * JS 가 돌기 전에도 헤더에 가리지 않도록 CSS 폴백은 약 132px 를 쓴다.
 *
 * 주의: .site-app--mall 에 CSS zoom 이 걸릴 수 있다.
 * getBoundingClientRect 는 시각(줌 후) 픽셀이라 sticky top(레이아웃 px)과
 * 어긋나므로 offsetHeight 를 기준으로 한다.
 */
const CSS_VAR = '--mall-header-offset'

/** 유틸줄 + 검색줄 + 카테고리 대략값. CSS fallback 과 맞춘다. */
export const MALL_HEADER_OFFSET_FALLBACK_PX = 132

export function publishMallHeaderOffset(root: HTMLElement = document.documentElement) {
  const head = document.querySelector('.mall-head') as HTMLElement | null
  if (!head) {
    root.style.setProperty(CSS_VAR, `${MALL_HEADER_OFFSET_FALLBACK_PX}px`)
    return MALL_HEADER_OFFSET_FALLBACK_PX
  }

  const px = Math.max(MALL_HEADER_OFFSET_FALLBACK_PX, Math.round(head.offsetHeight))
  root.style.setProperty(CSS_VAR, `${px}px`)
  return px
}

export function clearMallHeaderOffset(root: HTMLElement = document.documentElement) {
  root.style.removeProperty(CSS_VAR)
}
